import * as React from "react"
import { minicartWrapper, hiding, showing, closebtn, overlay } from "./minicart.module.css"

export function Minicart({ show, className, onClose, ...props }) {
  const [visible, setVisible] = React.useState(show)
  const [animation, setAnimation] = React.useState("")

  React.useEffect(() => {
    if (show) {
      setVisible(true)
      setAnimation(showing)
    } else {
      setAnimation(hiding)
    }

    // Add event listener when the component mounts
    document.addEventListener("click", handleClickOutside)

    // Cleanup function to remove event listener when the component unmounts
    return () => {
      document.removeEventListener("click", handleClickOutside)
    }
  }, [show])

  const handleClose = () => {
    setVisible(false)
    if (onClose) {
      onClose()
    }
  }

  const handleClickOutside = (event) => {
    // Close the Minicart if a click occurs outside of it
    if (visible && !event.target.closest(`.${minicartWrapper}`)) {
      handleClose()
    }
  }

  return (
    <div className={visible ? overlay : null}>
      {visible && (
        <div className={minicartWrapper}>
          <button onClick={handleClose} className={closebtn}>x</button>
          <div className={[animation, className].join(" ")} {...props}>
            {props.children}
          </div>
        </div>
      )}
    </div>
  )
}
